<template>
  <div id="app">
    <!-- 显示的是当前路由地址对应的内容 -->
    <!-- Detail页面不被缓存。每次进页面都执行一次AJAX,为了防止参数id不变 -->
    <!--<keep-alive exclude="Detail">-->
    <!--<router-view/>-->
    <!--</keep-alive>-->
    <div class="wrapper">
      <router-view />
    </div>
    <!-- <FooterBar v-if="$route.meta.showFooter"></FooterBar> -->
    <CookieNotice
      v-if="$store.state.cookieNoticeShow"
      @notAccept="notAccept"
    ></CookieNotice>

    <IpNotice
      v-if="$store.state.iPShow"
      @cancel="cancel"
      @confirm="confirm"
      :message="ipMessage"
    ></IpNotice>
  </div>
</template>

<script>
import FooterBar from "@/common/footer-bar/index.vue";
import CookieNotice from "./components/mycom/cookieNotice.vue";
import IpNotice from "@/components/mycom/ipNotice.vue";
import { Locale } from "vant";
import zhCN from "vant/es/locale/lang/zh-CN";
import enUS from "vant/es/locale/lang/en-US";
import Cookies from "js-cookie";
import { getIPCode } from "@/api/api.js";
import axios from "axios";
export default {
  name: "App",
  components: {
    FooterBar,
    CookieNotice,
    IpNotice,
  },
  data() {
    return {
      active: 1,
      cookieNoticeShow: false,
      dialogVisible: false,
      ipMessage: "Sorry, this network is unavailable.",
    };
  },
  methods: {
    notAccept(value) {
      this.cookieNoticeShow = value;
    },
    getIPCode() {
      axios({
        url: "https://www.weopinions.com/api/v1/IP2",
      }).then((res) => {
        const fullPath = this.$route.fullPath;
        const data = res.data.data;
        if (res.data.code === 200) {
          if (data.name === "China") {
            this.$store.commit("setIPShow", true);
            this.$store.commit("setIpCN", true);
            this.ipMessage = "Sorry, this network is unavailable.";
          } else if (data.name === "Japan") {
            // this.$store.commit("setIPShow", true);
            // this.ipMessage =
            //   "システムは、現在のIPが日本語領域にあることを決定し、Webサイトは対応する領域にリダイレクトします。本当に踊りますか。";
            this.newAddress = "https://jp.weopinions.com" + fullPath;
            window.location.href = this.newAddress;
          } else if (data.name === "Malaysia") {
            // this.$store.commit("setIPShow", true);
            // this.ipMessage =
            //   "Sistem menentukan IP semasa and a berada dalam kawasan bahasa Malay, dan laman akan menuju anda semula ke kawasan yang sepadan. Awak pasti nak lompat?";
            this.newAddress = "https://mas.weopinions.com";
            window.location.href = this.newAddress + fullPath;
          } else if (data.name === "Indonesia") {
            // this.$store.commit("setIPShow", true);
            // this.ipMessage =
            //   "Sistem menentukan bahwa IP Anda saat ini berada di daerah bahasa Indonesia, dan situs akan mengarahkan Anda kembali ke daerah yang sesuai. Kau yakin ingin melompat?";
            this.newAddress = "https://id.weopinions.com";
            window.location.href = this.newAddress + fullPath;
          } else if (data.name === "South Korea") {
            // this.$store.commit("setIPShow", true);
            // this.ipMessage =
            //   "현재 IP가 한국어 지역에 있는지 확인하면 웹 사이트에서 해당 지역으로 리디렉션됩니다.너 진짜 할 거야?";
            this.newAddress = "https://kr.weopinions.com";
            window.location.href = this.newAddress + fullPath;
          } else if (data.name === "Thailand") {
            // this.$store.commit("setIPShow", true);
            // this.ipMessage =
            //   "ระบบจะกำหนดว่า IP ปัจจุบันของคุณอยู่ในพื้นที่ภาษาไทย และเว็บไซต์จะเปลี่ยนเส้นทางไปยังพื้นที่ที่เหมาะสม แน่ใจนะว่าอยากกระโดด?";
            this.newAddress = "https://th.weopinions.com";
            window.location.href = this.newAddress + fullPath;
          } else if (data.name === "Vietnam") {
            // this.$store.commit("setIPShow", true);
            // this.ipMessage =
            //   "Hệ thống xác định rằng IP hiện tại của bạn nằm trong khu vực nói tiếng Việt và trang web sẽ chuyển hướng bạn đến khu vực tương ứng. Anh chắc là muốn nhảy chứ?";
            this.newAddress = "https://vn.weopinions.com";
            window.location.href = this.newAddress + fullPath;
          }
        }
      });

      // getIPCode().then((res) => {
      //   const fullPath = this.$route.fullPath;
      //   if (res.code === 200) {
      //     if (res.data.name === "China") {
      //       this.$store.commit("setIPShow", true);
      //       this.$store.commit("setIpCN", true);
      //       this.ipMessage = "Sorry, this network is unavailable.";
      //     } else if (res.data.name === "Japan") {
      //       // this.$store.commit("setIPShow", true);
      //       // this.ipMessage =
      //       //   "システムは、現在のIPが日本語領域にあることを決定し、Webサイトは対応する領域にリダイレクトします。本当に踊りますか。";
      //       this.newAddress = "https://jp.weopinions.com" + fullPath;
      //       window.location.href = this.newAddress;
      //     } else if (res.data.name === "Malaysia") {
      //       // this.$store.commit("setIPShow", true);
      //       // this.ipMessage =
      //       //   "Sistem menentukan IP semasa and a berada dalam kawasan bahasa Malay, dan laman akan menuju anda semula ke kawasan yang sepadan. Awak pasti nak lompat?";
      //       this.newAddress = "https://mas.weopinions.com";
      //       window.location.href = this.newAddress + fullPath;
      //     } else if (res.data.name === "Indonesia") {
      //       // this.$store.commit("setIPShow", true);
      //       // this.ipMessage =
      //       //   "Sistem menentukan bahwa IP Anda saat ini berada di daerah bahasa Indonesia, dan situs akan mengarahkan Anda kembali ke daerah yang sesuai. Kau yakin ingin melompat?";
      //       this.newAddress = "https://id.weopinions.com";
      //       window.location.href = this.newAddress + fullPath;
      //     } else if (res.data.name === "South Korea") {
      //       // this.$store.commit("setIPShow", true);
      //       // this.ipMessage =
      //       //   "현재 IP가 한국어 지역에 있는지 확인하면 웹 사이트에서 해당 지역으로 리디렉션됩니다.너 진짜 할 거야?";
      //       this.newAddress = "https://kr.weopinions.com";
      //       window.location.href = this.newAddress + fullPath;
      //     } else if (res.data.name === "Thailand") {
      //       // this.$store.commit("setIPShow", true);
      //       // this.ipMessage =
      //       //   "ระบบจะกำหนดว่า IP ปัจจุบันของคุณอยู่ในพื้นที่ภาษาไทย และเว็บไซต์จะเปลี่ยนเส้นทางไปยังพื้นที่ที่เหมาะสม แน่ใจนะว่าอยากกระโดด?";
      //       this.newAddress = "https://th.weopinions.com";
      //       window.location.href = this.newAddress + fullPath;
      //     } else if (res.data.name === "Vietnam") {
      //       // this.$store.commit("setIPShow", true);
      //       // this.ipMessage =
      //       //   "Hệ thống xác định rằng IP hiện tại của bạn nằm trong khu vực nói tiếng Việt và trang web sẽ chuyển hướng bạn đến khu vực tương ứng. Anh chắc là muốn nhảy chứ?";
      //       this.newAddress = "https://vn.weopinions.com";
      //       window.location.href = this.newAddress + fullPath;
      //     }
      //   }
      // });
    },
    //关闭ip提示弹框
    cancel() {
      this.$store.commit("setIPShow", false);
    },
    //确认ip跳转
    confirm() {
      this.$store.commit("setIPShow", false);
    },
  },
  mounted() {
    this.$i18n.locale = localStorage.getItem("lang") || "en";
    //canlendar本地化配置
    if (this.$i18n.locale === "zh") Locale.use("lang", zhCN);
    else Locale.use("lang", enUS);

    //console.log(122,this.$route.path)
    document.getElementById("app").style.maxWidth = 100 + "vw";
    document.getElementById("app").style.overflow = "auto";
    document.getElementsByClassName("wrapper")[0].style.overflow = "auto";
    // if (
    //   this.$route.path === "/questionnaireItem" ||
    //   this.$route.path === "/" ||
    //   this.$route.path === "/IntegralAward" ||
    //   this.$route.path === "/aboutQuestionnaire" ||
    //   this.$route.path === "/helpFeedback" ||
    //   this.$route.path === "/logon" ||
    //   this.$route.path === "/forgot" ||
    //   this.$route.path === "/login"
    // ) {
    //   document.getElementById("app").style.maxWidth = 100 + "vw";
    //   document.getElementById("app").style.overflow = "auto";
    //   document.getElementsByClassName("wrapper")[0].style.overflow = "auto";
    // } else {
    //   document.getElementById("app").style.maxWidth = 768 + "px";
    //   document.getElementById("app").style.overflow = "hidden";
    //   document.getElementsByClassName("wrapper")[0].style.overflow = "hidden";
    // }
  },
  created() {
    //用户选择不接受，可以在浏览器关闭前使用，关闭后后重新弹出
    if (Cookies.get("notaccept")) {
      return;
    }

    if (!Cookies.get("login") || Cookies.get("login") === "false") {
      this.$store.commit("setCookieNoticeShow", true);
    }

    this.getIPCode();
  },
};
</script>

<style lang="stylus">
#app {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.wrapper {
  width: 100%;
  height: 100%;
  background: #F3F3F3 !important;
  overflow: hidden;
}

.finished-text {
  position: relative;
  width: 100%;
  margin: 38px 0;
  display: flex;
  align-items: center;
  justify-content: center;

  &__line {
    height: 1px;
    position: absolute;
    background-color: #e1e1e1;
    width: 90%;
    left: 5%;
  }

  &__text {
    background-color: #f3f3f3;
    display: inline-block;
    padding: 0 10px;
    position: relative;
    z-index: 1;
    color: #847F7F;
    font-size: 0.2rem;
  }
}
</style>
<style scoped>
#app {
  width: 100%;
  min-height: 100vh;
  font-family: "Nunito", sans-serif;
  overflow: hidden;
  margin: 0 auto;
  max-width: 768px;
}
</style>


// WEBPACK FOOTER //
// src/App.vue